import * as PlanOut from 'planout';

export const VariantKey = 'variant';

export class BelongExperiment extends PlanOut.Experiment<any, any> {
  setup() {
    const { name, salt } = this.inputs;
    this.setName(name);
    this.setSalt(salt);
  }

  getParamNames() {
    return this.getDefaultParamNames();
  }

  assign(params: any, args: any) {
    const { choices, weights, unit } = args;
    params.set(
      VariantKey,
      new PlanOut.Ops.Random.WeightedChoice({ choices, weights, unit }),
    );
  }

  /* Required Implements */
  configureLogger() {}

  log() {}

  // previouslyLogged() {}
}
